export class ProductfinderNoresult {
  constructor() {}
}
